module.exports = __webpack_public_path__ + "static/media/Full_Modal_Header@3x.e4977f03.png";